import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { selectDeskId } from '@/redux/session/selectors';

/** Returns deskId from URL params, falling back to Redux state. */
export const useDeskId = (): string | null => {
  // eslint-disable-next-line no-restricted-syntax -- This hook IS the single source of truth
  const { deskId: deskIdFromUrl } = useParams<{ deskId: string }>();
  // eslint-disable-next-line no-restricted-syntax -- This hook IS the single source of truth
  const deskIdFromRedux = useSelector(selectDeskId);

  return deskIdFromUrl || deskIdFromRedux;
};
